export function formatDateTime(date){
    return new Date(date).toLocaleString('en-GB').replaceAll('/','.');
}